import { LegendKey } from "../../../../models/chart_model";
import { monthAbbrs } from "../constants";

/** Shallow-compare two arrays of LegendKey by dataKey and name */
export function legendsEqual(a: LegendKey[], b: LegendKey[]): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (a[i].dataKey !== b[i].dataKey || a[i].name !== b[i].name) return false;
  }
  return true;
}

export const parseMonthKey = (name?: string): number | null => {
  if (!name) return null;
  const trimmed = name.trim();
  const head6 = trimmed.slice(0, 6);
  const match = /^([A-Za-z]{3})-(\d{2})$/.exec(head6);
  if (!match) return null;
  const monthIdx = monthAbbrs.indexOf(match[1].toUpperCase());
  if (monthIdx < 0) return null;
  const yy = parseInt(match[2], 10);
  return (2000 + yy) * 12 + monthIdx;
};

export const compareLegends = (
  aName: string,
  bName: string,
  customLegendOrder?: string[],
) => {
  const aKey = parseMonthKey(aName);
  const bKey = parseMonthKey(bName);
  if (aKey !== null && bKey !== null) return aKey - bKey;
  if (aKey !== null && bKey === null) return -1;
  if (aKey === null && bKey !== null) return 1;

  if (customLegendOrder) {
    const ai = customLegendOrder.indexOf(aName);
    const bi = customLegendOrder.indexOf(bName);
    if (ai >= 0 && bi >= 0) return ai - bi;
    if (ai >= 0 && bi < 0) return -1;
    if (ai < 0 && bi >= 0) return 1;
  }

  return aName.toLowerCase().localeCompare(bName.toLowerCase());
};
